/**
 * @param {string} raw
 * @returns {string[]}
 */
export function parseCourseTagsInput(raw) {
  if (typeof raw !== "string") return [];
  const seen = new Set();
  const tags = [];
  for (const part of raw.split(",")) {
    const tag = part.trim();
    if (!tag || seen.has(tag.toLowerCase())) continue;
    seen.add(tag.toLowerCase());
    tags.push(tag.slice(0, 48));
    if (tags.length >= 12) break;
  }
  return tags;
}
